import { Injectable, OnDestroy, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class MobileLifecycleService implements OnDestroy {
  private readonly activeSignal = signal<boolean>(true);
  private readonly backButtonTapSignal = signal<number>(0);

  readonly isActive = this.activeSignal.asReadonly();
  readonly backButtonTapCount = this.backButtonTapSignal.asReadonly();

  constructor() {
    this.initialize();
  }

  ngOnDestroy(): void {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    window.removeEventListener("popstate", this.onPopState);
  }

  private initialize(): void {
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    window.addEventListener("popstate", this.onPopState);
    this.onVisibilityChange();
  }

  private readonly onVisibilityChange = () => {
    this.activeSignal.set(!document.hidden);
  };

  private readonly onPopState = () => {
    this.backButtonTapSignal.update((count) => count + 1);
  };
}
